// export const convert = (info, input, currency_to) => {
export const convert = (input, digit = 0) => {
  // let rate = info[currency_to];
  // let total = parseFloat(parseFloat(input * rate).toFixed(2)).toLocaleString(
  //   "th-TH",
  //   {
  //     useGrouping: true,
  //   }
  // );
  // return total || 0;

  let total = input?.toLocaleString("th-TH", {
    useGrouping: true,
  });

  if (digit) {
    total = input
      ? input?.toLocaleString("th-TH", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : 0;
  }
  return total || 0;
};
